export const LOAD_DISCOVER = 'LOAD_DISCOVER';
